import { scenesarray } from "./scenes/_index.js";

export const data = {
  scenes: [...scenesarray],

  name: "Project Title",
  settings: {
    mouseViewMode: "drag",
    autorotateEnabled: false,
    fullscreenButton: true,
    viewControlButtons: false,
  },
};
